import '@/style/app.scss';
import { initSentry } from '@/js/services/sentry.js';
import { initGDPRConsent } from '@/js/partials/gdpr-consent.js';
import { initHeader } from '@/js/partials/header.js';
import { initAuthForm } from '@/js/partials/inline-auth-form.js';

window.addEventListener('DOMContentLoaded', () => {
	initSentry();
	initGDPRConsent();
	initHeader();
	initAuthForm();
});
